/** @format */

import styled from 'styled-components';

export const RoomInfoHeader = styled.div`
  display: grid;
  grid-gap: 1.875rem;
  padding-top: 1rem;
  grid-template-columns: minmax(360px, 40.75rem) 1fr;
  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

export const RoomInfoContainer = styled.div`
  width: 100%;
  max-width: 40.75rem;
  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    max-width: 100%;
  }
`;

export const RoomInfoCode = styled.div`
  color: ${props => props.theme.colors.alternativeGrey};
  padding-block: 1.875rem 1.25rem;

  @media screen and (max-width: 1161px) {
    padding-bottom: 0;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
    padding-block: 0;
  }
`;

export const RoomInfoDescriptionArea = styled.div`
  min-height: 10vh;
  margin-bottom: 2.5rem;
  max-width: 40.75rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    max-width: 40.75rem;
    margin-bottom: 1.5rem;
  }
`;
